
import React from 'react'
import ContactInformationTable from './Componates/ContactInformationTable'
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import AddItemBtn from 'Common/Custom/AddItemBtn';

const ContactInformation = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Contact Information List</HeadingOne>
          <AddItemBtn url="add-contact-information" title="Create" />
        </>
      }
    >
      {/* Table section */}
      <div className="col-12">
        <ContactInformationTable />
      </div>
    </PageBody>
  );
};

export default ContactInformation;
